import type { TFunction } from "i18next";
import type { ProjectedValue } from "../../../api/threads/liveMessages";

/** The kinds whose size is named in their own words; any other set is so many items. */
const COUNTED = new Set(["annotations", "instance_data", "text_units"]);

/**
 * A value at a glance, as module C sums it up (WD-4): how a text begins, how many a set holds,
 * else what kind it is, in the Run view's words for kinds (`threads.toolTurn.valueKinds`). The
 * one wording for the run graph's cards, a plan's wired inputs and a switch's outputs.
 */
export function valueText(value: ProjectedValue, t: TFunction): string {
  if (value.text !== undefined && value.text !== null) return value.text;
  if (value.count !== undefined && value.count !== null) {
    return t(`threads.runGraph.count.${COUNTED.has(value.kind) ? value.kind : "other"}`, { count: value.count });
  }
  return t(`threads.toolTurn.valueKinds.${value.kind}`);
}
